/** Comment Intelligence — sort creators via dropdown (all rows shown). */

export const COMMENT_FILTERS = [
  { id: 'all', label: 'All creators' },
  { id: 'positive', label: 'Positive comments' },
  { id: 'negative', label: 'Negative comments' },
  { id: 'neutral', label: 'Neutral comments' },
  { id: 'unanswered', label: 'Unanswered questions' },
  { id: 'questions', label: 'Buyer questions' },
  { id: 'response_given', label: 'Response given' },
];

function num(c, key) {
  const v = c?.[key];
  return typeof v === 'number' && !Number.isNaN(v) ? v : 0;
}

function handleCompare(a, b) {
  return String(a?.instagram_handle || '').localeCompare(
    String(b?.instagram_handle || '')
  );
}

function sortDesc(list, primaryKey, secondaryKey) {
  list.sort((a, b) => {
    const diff = num(b, primaryKey) - num(a, primaryKey);
    if (diff !== 0) return diff;
    if (secondaryKey) {
      const d2 = num(b, secondaryKey) - num(a, secondaryKey);
      if (d2 !== 0) return d2;
    }
    return handleCompare(a, b);
  });
  return list;
}

/** Return a new array sorted for the selected dropdown option (no rows hidden). */
export function sortCommentCreators(creators, sortId) {
  const list = [...(creators || [])];
  const s = sortId || 'all';

  if (s === 'positive') return sortDesc(list, 'positive_count', 'ingested_count');
  if (s === 'negative') return sortDesc(list, 'negative_count', 'ingested_count');
  if (s === 'neutral') return sortDesc(list, 'neutral_count', 'ingested_count');
  if (s === 'unanswered') return sortDesc(list, 'unanswered_count', 'question_count');
  if (s === 'questions') return sortDesc(list, 'question_count', 'unanswered_count');
  if (s === 'response_given') {
    list.sort((a, b) => {
      const answered = num(b, 'answered_count') - num(a, 'answered_count');
      if (answered !== 0) return answered;
      const rate = num(b, 'response_rate_pct') - num(a, 'response_rate_pct');
      if (rate !== 0) return rate;
      return handleCompare(a, b);
    });
    return list;
  }

  return sortDesc(list, 'ingested_count', 'positive_count');
}

/** @deprecated use sortCommentCreators */
export function filterCommentCreators(creators, sortId) {
  return sortCommentCreators(creators, sortId);
}
